module.exports = __webpack_public_path__ + "img/select_class.a2d11f4b.gif";